import Swal from "sweetalert2";
import TranslateFile from "../../Loc/TranslateFile";

let modalOpen = false; // Flag to prevent multiple modals

function CustomModal({ content, onOkClick, color }) {
    if (modalOpen) return; // Exit if a modal is already open

    const currentLang = TranslateFile();

    modalOpen = true; // Set the flag when modal is opened

    Swal.fire({
        title: currentLang?.Message,
        html: `
            <div class="d-flex align-items-center justify-content-center">
                <p class="text-default-green">${content}</p>
            </div>
        `,
        icon: color === '#c8605e' ? 'error' : color === '#4a9a93' ? 'success' : 'info',
        showCancelButton: false,
        confirmButtonText: currentLang?.Buttons?.Ok,
        confirmButtonColor: color,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
            confirmButton: "btn button-primary",
            cancelButton: "btn button-secondary"
        },
        didOpen: () => {
            const confirmButton = Swal.getConfirmButton();
            if (confirmButton) {
                confirmButton.setAttribute('title', currentLang?.Buttons?.Ok);
            }
        }
    }).then((result) => {
        modalOpen = false; // Reset the flag when modal is closed

        if (result.isConfirmed) {
            onOkClick();
        }
    });
}

export default CustomModal;
